import { Collapse as WCollapse, CollapseProps } from '@blueprintjs/core';
import React, { FC, PropsWithChildren } from 'react';

const Collapse: FC<PropsWithChildren<CollapseProps>> = ({ children, ...props }) => (
  <WCollapse {...props}>{children}</WCollapse>
);

export default Collapse;
